import {FooterType} from "../app/FooterType";
import {otpDialog, PasswordValidation, PledgerAction} from "@pledger/frontend-commons";
import {PledgerPageComponentState} from "../../services/ui/PledgerPageComponentState";
import {Reducer} from "redux";
import {EnrollmentActions} from "./EnrollmentActions";
import {pageId} from "../../services/ui/AppPageManager";
import {EnrollmentStatusCode} from "../../services/ws/enrollmentToken/dto/EnrollmentStatusCode";
import {enrollmentWServiceActions} from "../../services/ws/enrollment/enrollmentWServiceActions";
import {OTPDialogState} from "@pledger/frontend-commons/dist/ui/components/dialogBoxes/OTPDialog/OTPDialogReducer";

const footerType = (state = FooterType.NONE, action : PledgerAction) => {
    switch (action.type) {
        default:
            return FooterType.NONE;
    }
};

const loaded = (state = false, action : PledgerAction) => {
    switch (action.type) {
        case enrollmentWServiceActions.GET_ENROLLMENT_STATE_SUCCEEDED_ACTION.type:
            return true;

        default:
            return state;
    }
};

const enrollmentStatus = (state = EnrollmentStatusCode.UNKNOWN, action : PledgerAction) => {
    switch (action.type) {
        case enrollmentWServiceActions.GET_ENROLLMENT_STATE_SUCCEEDED_ACTION.type:
            return action.payload.data.enrollmentStatus;

        case enrollmentWServiceActions.REGISTER_IDENTITY_SUCCEEDED_ACTION.type:
            return action.payload.data.enrollmentStatus;

        case enrollmentWServiceActions.PHONE_NUMBER_VALIDATION_SUCCEEDED_ACTION.type:
            return action.payload.data.enrollmentStatus;

        default:
            return state;
    }
};

const familyName = (state = '', action : PledgerAction) => {
    switch (action.type) {
        case EnrollmentActions.ENROLLMENT_CHANGE_FAMILY_NAME_ACTION.type:
            return action.payload.familyName;

        case enrollmentWServiceActions.GET_ENROLLMENT_STATE_SUCCEEDED_ACTION.type:
            return action.payload.data.lastName ?? '';

        default:
            return state;
    }
};

const firstName = (state = '', action : PledgerAction) => {
    switch (action.type) {
        case EnrollmentActions.ENROLLMENT_CHANGE_FIRST_NAME_ACTION.type:
            return action.payload.fisrtName;

        case enrollmentWServiceActions.GET_ENROLLMENT_STATE_SUCCEEDED_ACTION.type:
            return action.payload.data.firstName ?? '';

        default:
            return state;
    }
};

const telephone = (state = '', action : PledgerAction) => {
    switch (action.type) {
        case EnrollmentActions.ENROLLMENT_CHANGE_TELEPHONE_ACTION.type:
            return action.payload.telephone;

        case enrollmentWServiceActions.GET_ENROLLMENT_STATE_SUCCEEDED_ACTION.type:
            return action.payload.data.phoneNumber ?? state;

        default:
            return state;
    }
};

const telephoneInvalid = (state = false, action : PledgerAction) => {
    switch (action.type) {
        case enrollmentWServiceActions.REGISTER_IDENTITY_FAILED_ACTION.type:
            return true;
        case EnrollmentActions.ENROLLMENT_CHANGE_TELEPHONE_ACTION.type:
            return false;
        default:
            return state;
    }
};

const password = (state = '', action : PledgerAction) => {
    switch (action.type) {
        case EnrollmentActions.ENROLLMENT_CHANGE_PASSWORD_ACTION.type:
            return action.payload.password;

        default:
            return state;
    }
};

const passwordVerif = (state = '', action : PledgerAction) => {
    switch (action.type) {
        case EnrollmentActions.ENROLLMENT_CHANGE_PASSWORD_VERIF_ACTION.type:
            return action.payload.passwordVerif;

        default:
            return state;
    }
};

const passwordCaracValid = (state = false, action : PledgerAction) => {
    switch (action.type) {
        case EnrollmentActions.ENROLLMENT_CHANGE_PASSWORD_ACTION.type:
            return PasswordValidation.isPasswordLengthValid(action.payload.password);

        default:
            return state;
    }
};

const passwordCapitalValid = (state = false, action : PledgerAction) => {
    switch (action.type) {
        case EnrollmentActions.ENROLLMENT_CHANGE_PASSWORD_ACTION.type:
            return PasswordValidation.isPasswordCapitalValid(action.payload.password);

        default:
            return state;
    }
};

const passwordNumberValid = (state = false, action : PledgerAction) => {
    switch (action.type) {
        case EnrollmentActions.ENROLLMENT_CHANGE_PASSWORD_ACTION.type:
            return PasswordValidation.isPasswordNumberValid(action.payload.password);

        default:
            return state;
    }
};

const passwordSpecialCaracValid = (state = false, action : PledgerAction) => {
    switch (action.type) {
        case EnrollmentActions.ENROLLMENT_CHANGE_PASSWORD_ACTION.type:
            return PasswordValidation.isPasswordSpecialCharValid(action.payload.password);

        default:
            return state;
    }
};

export interface EnrollmentPageComponentState extends PledgerPageComponentState {
    loaded: boolean;
    enrollmentStatus: string;
    familyName: string;
    firstName: string;
    telephone: string;
    telephoneInvalid: boolean;
    password: string;
    passwordVerif: string;
    passwordCaracValid: boolean;
    passwordCapitalValid: boolean;
    passwordNumberValid: boolean;
    passwordSpecialCaracValid: boolean;
    otpDialog: OTPDialogState;
}

export const enrollment : Reducer = (state={},action)=>{
    return{
        pageId:pageId(state.pageId,action),
        footerType: footerType(state.footerType, action),
        loaded: loaded(state.loaded, action),
        enrollmentStatus: enrollmentStatus(state.enrollmentStatus, action),
        familyName: familyName(state.familyName, action),
        firstName: firstName(state.firstName, action),
        telephone: telephone(state.telephone, action),
        telephoneInvalid: telephoneInvalid(state.telephoneInvalid, action),
        password: password(state.password, action),
        passwordVerif: passwordVerif(state.passwordVerif, action),
        passwordCaracValid: passwordCaracValid(state.passwordCaracValid, action),
        passwordCapitalValid: passwordCapitalValid(state.passwordCapitalValid, action),
        passwordNumberValid: passwordNumberValid(state.passwordNumberValid, action),
        passwordSpecialCaracValid: passwordSpecialCaracValid(state.passwordSpecialCaracValid, action),
        otpDialog:otpDialog(state.otpDialog,action)
    }
}
